import SensitiveTextarea from "src/components/inputs/SensitiveTextarea";

interface Hl7ConfigTabProps {
  hl7ConnectorJwtSecret: string;
  onHl7ConnectorJwtSecretChange: (value: string) => void;
  disableInputs: boolean;
}

const Hl7ConfigTab = ({
  hl7ConnectorJwtSecret,
  onHl7ConnectorJwtSecretChange,
  disableInputs,
}: Hl7ConfigTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">HL7</h3>
    <div className="mt-4 space-y-4">
      <SensitiveTextarea
        label="HL7 Connector JWT Secret"
        placeholder="Enter HL7 Connector JWT secret"
        value={hl7ConnectorJwtSecret}
        onChange={onHl7ConnectorJwtSecretChange}
        required={false}
        disabled={disableInputs}
      />
    </div>
  </>
);

export default Hl7ConfigTab;
